import type { TrackedButtonClickName } from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  trackedButtonName: TrackedButtonClickName;
};

class WtbToggleViewEvent extends UserEvent<EventData> {
  collectServerEvents() {
    const type =
      this.data.trackedButtonName === 'SHOW_ALL_RETAILERS'
        ? 'show_all_retailers_click'
        : 'show_all_raffles_click';

    this.serverEvents.push({ type });
  }
}

export default WtbToggleViewEvent;
